export { sendEvent } from 'next-flight-server-reference-proxy-loader?id=7f85ea56bea5bafe370315f263b0d7530f8378da0c&name=sendEvent!'